// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import store from 'store/index'
import 'babel-polyfill'
import 'static/font/iconfont.css'
import 'static/font2/iconfont.css'
import 'swiper/dist/css/swiper.css'
import axios from "axios"
// import 'static/js/windowFit'
import 'common/theme/index.css'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

import {
  Tree,
  Select,
  Option,
  OptionGroup,
  Radio,
  RadioGroup,
  MessageBox,
  Message,
  Rate,
  Dialog,
  Loading,
  Switch,
  Carousel,
  CarouselItem,
} from 'element-ui'
Vue.use(Loading)
Vue.use(Tree)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Rate)
Vue.use(Dialog)
Vue.use(Switch)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.prototype.$confirm = MessageBox.confirm;

if (window.location.href.indexOf("token") != -1) {
  console.log(getQueryVariable('token'))
  if (getQueryVariable('token')) {
    axios.defaults.headers.post['token'] = getQueryVariable('token')
  }
}

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return (false);
}

/**
 * 引入jquery
 */
//import $ from 'jquery'

import echarts from 'echarts'

Vue.prototype.$echarts = echarts

/**
 * vue轮播：vue-awesome-swiper
 * 全局注册
 */
import VueAwesomeSwiper from 'vue-awesome-swiper'

Vue.use(VueAwesomeSwiper)

/**
 * tab选项卡：vue-nav-tabs
 * 全局注册
 */
import VueTabs from 'vue-nav-tabs'

Vue.use(VueTabs);

/**
 * QS
 */
import qs from 'qs'

Vue.prototype.$qs = qs
/***
 * vue模态框：vue-js-modal
 * 全局注册
 */
import VModal from 'vue-js-modal'

Vue.use(VModal, {dynamic: true});
/***
 * vue Grid：vue-easytable
 * VTable:表格组件
 * VPagination:表格分页组件
 * @type {boolean}
 */
import 'static/css/vgrid.css'
import 'vue-easytable/libs/themes-base/index.css'
import {VTable, VPagination} from 'vue-easytable'
import apiConfig from "common/js/api_config";
Vue.component(VTable.name, VTable);
Vue.component(VPagination.name, VPagination);

/***
 * 下拉菜单:vue-select
 * @type {boolean}
 *
 */
import vSelect from 'vue-select'

Vue.component('v-select', vSelect)

/***
 * 提示框组件
 * @type {boolean}
 */
import Notifications from 'vue-notification'

Vue.use(Notifications)

Vue.config.productionTip = false;

/***
 * wangEditor
 * 富文本编辑器组件
 */

import VEditor from 'yimo-vue-editor'
Vue.prototype.$axios = axios
Vue.prototype.$apiConfig = apiConfig
Vue.use(VEditor, {
  name: 'v-editor-app',//Custom name
  config: {
    hideLinkImg: false,
    showLinkImg: false,
    uploadImgUrl: false,
  },//wagnEditor config
  uploadHandler: (type, resTxt) => {//Upload processing hook
    if (type === 'success') {
      var res = JSON.parse(resTxt)//Do not process the default look at the return value bit image path
      if (res.status !== 1) {
        return null
      }
      return res.data
    } else if (type === 'error') {
      //todo toast
    } else if (type === 'timeout') {
      //todo toast
    }
    return 'upload failed__'
  }
});

/***
 * 全局异常处理
 * @param error
 * @param vm
 */
const errorHandler = (error, vm) => {
  console.error('抛出全局异常');
  console.error(vm);
  console.error(error);
};

Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = function (error) {
  errorHandler(error, this)
};


/****
 * 数组扩展方法
 */

Array.prototype.remove = function (val) {
  var index = this.indexOf(val);
  if (index > -1) {
    this.splice(index, 1);
  }
};


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: {App},
  template: '<App/>',
  mounted: function () {
  
  }
})



// WEBPACK FOOTER //
// ./src/main.js